import React from "react";
import { Select } from "../../../../../../shared/infrastructure/ui";
import { SelectComponentProps } from "./types";
import { useInfiniteGetRevenueCodes } from "../../../services";
import { withSelectOptions } from "./with-select-options";
import {
  RevenueCodeT,
  UseGetRevenueCodeFilters,
} from "../../../../domain/entities";

const RenderOption = ({
  description,
  id,
}: RevenueCodeT): React.ReactElement => {
  return (
    <section className="grid w-[300px] grid-flow-col items-center justify-between px-[5px] text-[12px]">
      <span>{description ?? "- -"}</span>
      <span className="rounded-[5px] bg-[#F4F4F4] py-[5px] px-[10px] text-[10px]">
        {id ?? "- -"}
      </span>
    </section>
  );
};

const RevenueCodeSelectComponent = ({
  placeholder,
  name = "",
  selectedValue,
  onChangeValue,
  error = "",
  variant = "standard",
  disabled = false,
  handleSetKeyword,
  isLoading,
  getNextPage,
  noMore,
  data,
  noError,
  labelProp = "description",
  keyword,
  multiselect,
}: SelectComponentProps<RevenueCodeT>): React.ReactElement => {
  return (
    <Select<RevenueCodeT>
      searchValue={keyword}
      multiselect={multiselect}
      disabled={disabled}
      loading={isLoading}
      placeholder={placeholder}
      options={data}
      name={name}
      asyncFilter={handleSetKeyword}
      labelProp={labelProp}
      value={selectedValue}
      onChange={onChangeValue}
      noMore={noMore}
      getMore={getNextPage}
      renderOptionComponent={RenderOption}
      error={error}
      variant={variant}
      noError={noError}
    />
  );
};

export const RevenueCodeSelect = withSelectOptions<
  RevenueCodeT,
  UseGetRevenueCodeFilters
>(RevenueCodeSelectComponent, useInfiniteGetRevenueCodes, "id");
